import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let changXinRouter = new Router({
  mode: 'history', // 添加这一行，启用历史模式
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
      meta: {
        title: "长芯光电科技有限公司"
      }
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('./views/Solution.vue'),
      meta: {
        title: "解决方案"
      }
    },
    {
      path: '/solution/solutionDetailsJGYM',
      name: 'solutionDetailsJGYM',
      component: () => import('./views/Solution/SolutionDetailsJGYM.vue'),
      meta: {
        title: "激光育苗"
      }
    },
    {
      path: '/solution/solutionDetailsGSZZ',
      name: 'solutionDetailsGSZZ',
      component: () => import('./views/Solution/SolutionDetailsGSZZ.vue'),
      meta: {
        title: "果蔬种植"
      }
    },
    {
      path: '/solution/solutionDetailsJJZW',
      name: 'solutionDetailsJJZW',
      component: () => import('./views/Solution/SolutionDetailsJJZW.vue'),
      meta: {
        title: "经济作物"
      }
    },
    {
      path: '/solution/solutionDetailsNGHB',
      name: 'solutionDetailsNGHB',
      component: () => import('./views/Solution/SolutionDetailsNGHB.vue'),
      meta: {
        title: "农光互补"
      }
    },
    {
      path: '/solution/solutionDetailsDCZZ',
      name: 'solutionDetailsDCZZ',
      component: () => import('./views/Solution/SolutionDetailsDCZZ.vue'),
      meta: {
        title: "多层种植"
      }
    },
    {
      path: '/SolutionDetails/:id',
      name: 'SolutionDetails',
      component: () => import('./views/SolutionDetails.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
      meta: {
        title: "产品中心"
      }
    },
    {
      path: '/product/productDetailsBH',
      name: 'productDetailsBH',
      component: () => import('./views/Product/ProductDetailsBH.vue'),
      meta: {
        title: "冰火系列"
      }
    },
    {
      path: '/product/productDetailsXD',
      name: 'productDetailsXD',
      component: () => import('./views/Product/ProductDetailsXD.vue'),
      meta: {
        title: "炫碟系列"
      }
    },
    {
      path: '/product/productDetailsFP',
      name: 'productDetailsFP',
      component: () => import('./views/Product/ProductDetailsFP.vue'),
      meta: {
        title: "飞瀑系列"
      }
    },
    {
      path: '/product/productDetailsZM',
      name: 'productDetailsZM',
      component: () => import('./views/Product/ProductDetailsZM.vue'),
      meta: {
        title: "种苗系列"
      }
    },
    {
      path: '/product/productDetailsCS',
      name: 'productDetailsCS',
      component: () => import('./views/Product/ProductDetailsCS.vue'),
      meta: {
        title: "城市阳台系列"
      }
    },
    {
      path: '/product/productDetailsJG',
      name: 'productDetailsJG',
      component: () => import('./views/Product/ProductDetailsJG.vue'),
      meta: {
        title: "菌菇工厂系列"
      }
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('./views/Case.vue'),
      meta: {
        title: "案例展示"
      }
    },
    {
      path: '/case/caseDetailsZLS',
      name: 'caseDetailsZLS',
      component: () => import('./views/Case/CaseDetailsZLS.vue'),
      meta: {
        title: "主粮食案例"
      }
    },
    {
      path: '/case/caseDetailsZCY',
      name: 'caseDetailsZCY',
      component: () => import('./views/Case/CaseDetailsZCY.vue'),
      meta: {
        title: "中草药案例"
      }
    },
    {
      path: '/case/caseDetailsSC',
      name: 'caseDetailsSC',
      component: () => import('./views/Case/CaseDetailsSC.vue'),
      meta: {
        title: "蔬菜案例"
      }
    },
    {
      path: '/case/caseDetailsSG',
      name: 'caseDetailsSG',
      component: () => import('./views/Case/CaseDetailsSG.vue'),
      meta: {
        title: "水果案例"
      }
    },
    {
      path: '/case/caseDetailsHH',
      name: 'caseDetailsHH',
      component: () => import('./views/Case/CaseDetailsHH.vue'),
      meta: {
        title: "花卉案例"
      }
    },
    {
      path: '/case/caseDetailsNGHB',
      name: 'caseDetailsNGHB',
      component: () => import('./views/Case/CaseDetailsNGHB.vue'),
      meta: {
        title: "农光互补案例"
      }
    },
    // {
    //   path: '/caseDetails/:id',
    //   name: 'caseDetails',
    //   component: () => import('./views/CaseDetails.vue')
    // },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
      redirect:"/about/know",
      meta: {
        title: "关于长芯"
      },
      children: [
        {
          path: 'know',
          name: 'know',
          component: () => import('./views/About/Know.vue'),
          meta: {
            title: "认识长芯"
          },
        },{
          path: 'honor',
          name: 'honor',
          component: () => import('./views/About/Honor.vue'),
          meta: {
            title: "荣誉资质"
          },
        },{
          path: 'patent',
          name: 'patent',
          component: () => import('./views/About/Patent.vue'),
          meta: {
            title: "专利证书"
          },
        }
      ]
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('./views/Service.vue'),
      redirect:"/service/info",
      meta: {
        title: "技术支持"
      },
      children: [
        {
          path: 'info',
          name: 'info',
          component: () => import('./views/Service/ServiceInfo.vue'),
          meta: {
            title: "服务优势"
          },
        },{
          path: 'faq',
          name: 'faq',
          component: () => import('./views/Service/ServiceFaq.vue'),
          meta: {
            title: "常见问题"
          },
        },
        {
          path: 'down',
          name: 'down',
          component: () => import('./views/Service/ServiceDown.vue'),
          meta: {
            title: "下载中心"
          },
        }
      ]
    },
    // {
    //   path: '/problemDetails',
    //   name: 'problemDetails',
    //   component: () => import('./views/ProblemDetails.vue')
    // },
    // {
    //   path: '/download',
    //   name: 'download',
    //   component: () => import('./views/Download.vue')
    // },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue'),
      meta: {
        title: "联系我们"
      }
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import('./views/Login.vue')
    // },
    // {
    //   path: '/admin',
    //   name: 'admin',
    //   meta: {
    //     requireAuth: true
    //     // requireAuth: false
    //   },
    //   component: () => import('./views/Admin.vue'),
    //   children: [{
    //       path: '/admin/user',
    //       name: 'user',
    //       component: () => import('./views/Admin/User.vue')
    //     },
    //     {
    //       path: '/admin/news',
    //       name: 'new',
    //       component: () => import('./views/Admin/News.vue')
    //     },
    //     {
    //       path: '/admin/cases',
    //       name: 'cases',
    //       component: () => import('./views/Admin/Cases.vue')
    //     },
    //     {
    //       path: '/admin/team',
    //       name: 'team',
    //       component: () => import('./views/Admin/Team.vue')
    //     },
    //     {
    //       path: '/admin/course',
    //       name: 'course',
    //       component: () => import('./views/Admin/Course.vue')
    //     },
    //     {
    //       path: '/admin/enterprise',
    //       name: 'enterprise',
    //       component: () => import('./views/Admin/Enterprise.vue')
    //     },
    //     {
    //       path: '/admin/honor',
    //       name: 'honor',
    //       component: () => import('./views/Admin/Honor.vue')
    //     },
    //     {
    //       path: '/admin/dictionary',
    //       name: 'dictionary',
    //       component: () => import('./views/Admin/Dictionary.vue')
    //     },
    //     {
    //       path: '/admin/page',
    //       name: 'page',
    //       component: () => import('./views/Admin/Page.vue')
    //     }
    //   ]
    // }
  ]
})


// 判断是否需要登录权限 以及是否登录
changXinRouter.beforeEach((to, from, next) => {
  // // 判断是否需要登录权限
  // if (to.matched.some(res => res.meta.requireAuth)) {
  //   // 判断是否登录
  //   if (sessionStorage.getItem('token')) {
  //     next()
  //   } else {
  //     // 没登录则跳转到登录界面
  //     next({
  //       path: '/login',
  //       query: {
  //         redirect: to.fullPath
  //       }
  //     })
  //   }
  // } else {
  //   next()
  // }

  // alert(to.path)

  if (to.path.startsWith("/about")) {
    sessionStorage.setItem('keyPath', "/about");
  } else if (to.path.startsWith("/service")) {
    sessionStorage.setItem('keyPath', "/service");
  } else if (to.path.startsWith("/solution")) {
    sessionStorage.setItem('keyPath', "/solution");
  } else if (to.path.startsWith("/product")) {
    sessionStorage.setItem('keyPath', "/product");
  } else if (to.path.startsWith("/case")) {
    sessionStorage.setItem('keyPath', "/case");
  }else {
    sessionStorage.setItem('keyPath', to.path);
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()

  // this.$nextTick(() => {
  //    this.$forceUpdate()
  // })

})

export default changXinRouter;
